import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { DataSyncProvider } from '../context/DataSyncContext';

export function Layout() {
  return (
    <DataSyncProvider>
      <div className="app-shell">
        <Navbar />
        <main className="app-shell__content">
          <Outlet />
        </main>
      </div>
    </DataSyncProvider>
  );
}
